import cx from "classnames";
import { IonButton, IonLabel } from "@ionic/react";

import s from "./WebPaymentLanding.module.scss";
import qrCode from "../../assets/images/app-qr-code.png";
import appStoreLogo from "../../assets/images/app-store-badge.png";
import playStoreLogo from "../../assets/images/google-play-badge.png";
import EasyOnboardingQr from "./EasyOnboardingDownload/EasyOnboardingQr";
import { useEasyOnboardingStoreOpen } from "./EasyOnboardingDownload/useEasyOnboardingStoreOpen";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/winners-locker/id6454697542";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.winnerslocker.winnerslocker";

export const WLDownloadButtons = () => {
  const openAppStore = useEasyOnboardingStoreOpen(APP_STORE_URL);
  const openPlayStore = useEasyOnboardingStoreOpen(PLAY_STORE_URL);

  return (
    <div className={s.downloadOptions}>
      <div className={s.scanCodeContainer}>
        <EasyOnboardingQr
          staticQrSrc={qrCode}
          qrClassName={s.scanQrCode}
          scanTextClassName={cx("win-sub medium gilroy", s.scanLabel)}
          scanLabel="Scan to download the app"
        />
      </div>

      <div className={s.downloadButtonsContainer}>
        <IonButton
          fill="clear"
          className="ion-no-padding"
          onClick={openAppStore}
        >
          <img className={s.downloadButtonImage} src={appStoreLogo} alt="" loading="lazy" decoding="async" />
        </IonButton>
        <IonButton
          fill="clear"
          className="ion-no-padding"
          onClick={openPlayStore}
        >
          <img className={s.downloadButtonImage} src={playStoreLogo} alt="" loading="lazy" decoding="async" />
        </IonButton>
      </div>
    </div>
  );
};
